import { render } from "./HomeIndex.vue?vue&type=template&id=030f135e&scoped=true&ts=true"
import script from "./HomeIndex.vue?vue&type=script&lang=ts"
export * from "./HomeIndex.vue?vue&type=script&lang=ts"

import "./HomeIndex.vue?vue&type=style&index=0&id=030f135e&scoped=true&lang=css"

import exportComponent from "/Users/vav/Dev/eco-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030f135e"]])

export default __exports__